import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import { useOverlayContext } from 'seagull';
import { EditClientModal } from '../EditClientModal';
export function useOpenEditClientModal() {
    const { showModal } = useOverlayContext();
    return useCallback((args)=>showModal({
            biName: 'edit_client',
            content: (param)=>{
                let { dismissModal } = param;
                return /*#__PURE__*/ _jsx(EditClientModal, _object_spread_props(_object_spread({}, args), {
                    dismissModal: dismissModal
                }));
            }
        }), []);
}
